export function privateEmail(email) {
   let parts = email.split("@");
   let hidde = Object.keys(parts[0].substr(3)).map(() => "*");

   return `${parts[0].substr(0, 3)}${hidde.toString().replace(/,/g, "")}@${parts[1]}`;
}
